import { render, staticRenderFns } from "./jxstu_graduatelist.vue?vue&type=template&id=284425f8&scoped=true&"
import script from "./jxstu_graduatelist.vue?vue&type=script&lang=js&"
export * from "./jxstu_graduatelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284425f8",
  null
  
)

export default component.exports